import { render } from "./BaseSpinner.vue?vue&type=template&id=40cc790d&scoped=true&ts=true"
import script from "./BaseSpinner.vue?vue&type=script&lang=ts"
export * from "./BaseSpinner.vue?vue&type=script&lang=ts"

import "./BaseSpinner.vue?vue&type=style&index=0&id=40cc790d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cc790d"]])

export default __exports__